export default {

  ProElementInfo : {
    "abatementAcount":"免赔额",
    "abatementAcountPrem":"免赔调整保费人均保费",
    "abatementType":"免赔方式",
    "acciAddDeathAmount":"雇主责任保险伤残回附加条教责任",
    "acciAddDeathPrem":"雇主责任保险伤残回附加条教责任人均保费",
    "acciDeathAmount":"意外身故、伤残/意外伤害(主险保额)",
    "acciDeathPrem":"意外身故、伤残人均保费",
    "acciDentalDeath":"24小时意外身故伤残",
    "accidentMedicalAmount":"24小时意外医疗",
    "acciHospitalAmount":"意外住院/住院津贴/每日住院人均保额",
    "acciHospitalPrem":"意外住院/住院津贴/每日住院人均保费",
    "acciHospitalSubsidyAmount":"意外住院津贴保额(重症监护病房)",
    "acciHospitalSubsidyPrem":"意外住院津贴保费(重症监护病房)",
    "acciRemedyAmount":"意外医疗(门诊/急诊/住院)",
    "acciRemedyExtendAmount":"意外医疗扩展责任(自费药)",
    "acciRemedyExtendPrem":"意外医疗扩展责任(自费药)人均保费",
    "acciRemedyNoFran":"意外医疗费用补偿（无免赔额，扩展社保外医疗）",
    "acciRemedyPrem":"意外医疗(门诊/急诊/住院)人均保费",
    "acciVaccinationDeath":"预防接种意外身故、残疾",
    "acciVaccinationMedical":"预防接种意外医疗",
    "addAmbulanceFare":"附加救护车车费",
    "additional":"附加甲乙类传染病",
    "additionalClause":"附加24小时意外扩展条款",
    "additionalClausePer":"附加24小时意外扩展条款人均保费",
    "addPrem":"加费金额",
    "addPremiumAmount":"保额(附加险)",
    "advertisingDecoration":"扩展广告及装饰配置责任",
    "advertisingDecorationPrem":"扩展广告及装饰配置责任保费",
    "aircraftAcciAmount":"飞机意外伤亡保额",
    "aircraftAcciPrem":"飞机意外伤亡保费",
    "allowanceJandY":"甲乙类法定传染病确诊津贴",
    "annualIncome":"年收入",
    "aplPersonNum":"投保人数（RPA产品配置）",
    "areaCode":"地区代码(地区省级代码)",
    "asiaOverseasMedical":"亚洲海外医疗",
    "bedsNumber":"床位数",
    "bidOpenTime":"开标时间(投标保证金)",
    "bidSecurity":"保证金(投标保证金)",
    "bunkNum":"住宿责任险营业规模（床位数）",
    "businessArea":"营业面积",
    "carInfo":"车辆信息",
    "carModelName":"车辆品牌型号",
    "carNo":"车牌号码",
    "carQuality":"车辆核定载质量",
    "carSeatNumber":"(carSeatNumber)车辆座位数",
    "carType":"车辆类型",
    "carUseProperty":"车辆使用性质",
    "cashAmount":"店内现金数额",
    "civilAviationAcci":"乘坐民航客机意外身故及伤残",
    "classificationOfIndustries":"行业分类等级",
    "commencementDate":"开工日期",
    "compensateAcount":"累计赔偿限额/车",
    "compensateCarOnce":"单次运输赔偿限额/车",
    "completionDate":"完工日期",
    "contractID":"合约ID",
    "deathOfIllness":"疾病身故",
    "deductibleRatio":"免赔额和赔付比例",
    "defineJobCode":"e家自定义职业",
    "dirveCarProperties":"驾驶车辆性质",
    "disabilityGrade":"伤残等级保额",
    "disabilityGradePrem":"伤残等级人均保费",
    "disabilityPrem":"伤残等级保费",
    "diseaseHospital":"疾病住院",
    "diseaseHospitalPer":"疾病住院人均保费",
    "diseaseMedicalTreatment":"疾病医疗",
    "dormitoryScale":"住宿规模",
    "elevator":"扩展电梯责任",
    "elevatorCount":"电梯数量",
    "elevatorPrem":"扩展电梯责任保费",
    "engineeringCost":"工程造价",
    "engineeringName":"工程名称",
    "engineNumber":"发动机号",
    "enterpriseNo":"投保企业编号",
    "everyAccidentAcount":"每次事故绝对免赔额(主险)",
    "everyAccidentAddAcount":"每次事故绝对免赔额(附加险)",
    "everyAccidentLimit":"每次事故限额",
    "everyoneAddLimit":"单次赔偿限额(附加险)",
    "everyoneLimit":"每人赔偿限额",
    "everyYearAddPrem":"保费/年(附加险)",
    "everyYearPrem":"保费/年(主险)",
    "flagration":"扩展火灾爆炸责任",
    "flagrationPrem":"扩展火灾爆炸责任保费",
    "frameNumber":"车架号(后四位)",
    "frameNumberAll":"车架号",
    "fullAddress":"详细地址",
    "handCarNo":"挂车车牌号",
    "hourAcciDeathAmount":"24小时保障意外身故伤残",
    "iLinpublicPlace":"附加公共场所个人责任保险",
    "iLinpublicPlacePrem":"附加公共场所个人责任保险人均保费",
    "individualLiability":"个人责任",
    "industry":"行业类型",
    "industryFine":"行业三级",
    "industryGrade":"行业等级",
    "industryLarge":"行业一级",
    "industryLeast":"行业四级",
    "industryMiddle":"行业二级",
    "injuryRatio":"投保工伤比例",
    "insuPersonNum":"投保人数",
    "insuranceType":"险种",
    "insureNumber":"投保份数",
    "insurePerioAdjustFactor":"投保期限调整系数",
    "interSecdIagnosisTreatment":"恶性肿瘤国际二次诊疗",
    "inventoryValue":"店内存货价值",
    "isdPersonType":"被保人类型",
    "isExpandedMaim":"是否扩展伤残比例",
    "isHigh":"是否高空作业",
    "isInjury":"是否投保工伤",
    "jobCode":"职业",
    "jobFine":"职业细类",
    "jobGrade":"职业等级",
    "jobLarge":"职业大类",
    "jobMiddle":"职业中类",
    "legalJandY":"甲乙类法定传染病身故",
    "locationOfUnit":"投保单位所在地",
    "manageType":"经营类型",
    "medicalInsurance":"有无医保",
    "noOperatingVehicleAcciAmount":"乘坐非营运机动车",
    "noOperatingvehicleAcciPrem":"乘坐非营运机动车人均保费",
    "novelCoronavirus":"新冠肺炎确诊集中隔离费用",
    "occupationalCoefficient":"职业系数",
    "oneOffEmploymentGrant":"一次性就业补助金",
    "oneOffEmploymentGrantPrem":"一次性就业补助金人均保费",
    "ownerCertificateNo":"所有人证件号码",
    "ownerCertificateType":"所有人证件类型",
    "perCcFraud":"个人银行卡盗刷",
    "personalSecurityBene":"个人保障利益(xx款,xx计划)",
    "poundageRatio":"手续费比例(代理公司佣金)",
    "premiumAmount":"保额（主险）",
    "premSum":"保险费小计",
    "productCode":"产品代码",
    "proHeavYion":"质子重离子",
    "project"	:	"项目",
    "projectAddress":"项目所在地（投标保证金）",
    "projectName":"项目名称(投标保证金)",
    "propertyLessLimit":"每次财产损失赔偿限额",
    "protectionType":"保障类型",
    "ratioOfSurcharge":"加费比例",
    "regionalCoefficient":"地区系数",
    "regulationFactor":"调整系数",
    "remark":"备注",
    "remoteReferral":"异地转诊交通费",
    "responsibilities":"扩展食品饮料责任",
    "responsibilitiesPrem":"扩展食品饮料责任保费",
    "roomsNumber":"房间数",
    "route":"行程",
    "sameAsMedSecurity":"一般医疗保险金",
    "schemCode":"方案代码",
    "scheme":"方案",
    "schemName":"方案名称",
    "schoolType":"学校类型",
    "securePlan":"保险计划",
    "selfDrivingAmount":"自驾车保额",
    "selfDrivingPrem":"自驾车保费",
    "shipAcciAmount":"客运轮船意外保额",
    "shipAcciPrem":"客运轮船意外保费",
    "spare":"备用",
    "specialregulationFactor":"特殊行业调整系数",
    "storeProperty":"店内财产价值",
    "studentNum":"学员人数",
    "suddenDeath":"猝死",
    "suddenDeathPrem":"猝死保费",
    "sumCompensationLimit":"累计赔偿限额",
    "sumCompensationLimitPrem":"累计赔偿限额人均保费",
    "suppleMedical":"补充住院医疗",
    "takeOtherTrafficAcci":"乘坐除民航客机外的其他公共交通工具意外身故及残疾",
    "tardyJobPerPrem":"误工费人均保费",
    "tardyJobPrem":"误工费",
    "targetedDrug":"院外靶向药报销",
    "termPlan":"期限计划",
    "therioma":"恶性肿瘤医疗保险金",
    "theriomaPrem":"恶性肿瘤保障金",
    "theriomaSubsidyAmount":"恶心肿瘤住院津贴",
    "touristDestination":"旅游目的地",
    "trackAcciAmount":"轨道交通意外保额",
    "trackAcciPrem":"轨道交通意外保费",
    "trafficInsueSort":"交通保险类别",
    "transGoodsType":"运输货物类型",
    "transType":"运输方式",
    "vehicleAcciAmount":"机动车意外保额",
    "vehicleAcciPrem":"机动车意外保费",
    "vehicleOwner":"车辆所有权人",
    "workType":"工种",
  }

}



// WEBPACK FOOTER //
// ./src/tool/ejsinoProElementInfo.js